var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"neilian"},[(_vm.show)?_c('iframe',{staticStyle:{"height":"800px","width":"1200px","margin":"0 auto"},attrs:{"src":_vm.url,"frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }